import { useQuery } from "react-query";
import { getMaterialRequests } from "../../../services/api/materialRequests";
import { getMaterials } from "../../../services/api/materials";
import { MATERIALS_QUERY_KEY } from "../materials/useMaterials";
import {
  Material,
  MaterialRequest,
  Options,
  QueryListResult
} from "../utils/types";

export const MATERIAL_REQUESTS_QUERY_KEY = "Q_MATERIAL_REQUEST_COMPANY";
export type UseCompanyMaterialRequestsType = Options;

export const useCompanyMaterialRequests = (
  eventId: string,
  companyId: string,
  options: UseCompanyMaterialRequestsType = {}
) => {
  let { page, size, sort, include, ...rest } = options;

  if (!page) page = 0;
  if (!size) size = 50;
  if (!sort) sort = "-created_at";

  const filters = {
    "page[number]": page,
    "page[size]": size,
    sort,
    include,
    ...rest
  };

  return useQuery<QueryListResult<MaterialRequest>>(
    [MATERIAL_REQUESTS_QUERY_KEY, page, size, sort, include],
    () => getMaterialRequests(companyId, filters),
    { enabled: options.enabled }
  );
};
